// src/api/plannerreport.ts
//
// Daily Planner reports — mirrors taskreport.ts but hits /tasks/reports/planner
// (the planner_reports router, which aggregates the `todos` table). Returns are
// loosely typed (any) — the report page reads fields directly.
import api from './api';

type DateFilters = { start_date?: string; end_date?: string };

// GET /tasks/reports/planner/overview
export const getPlannerOverview = async (filters: DateFilters = {}) => {
  const res = await api.get('/tasks/reports/planner/overview', { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/employees
export const getPlannerEmployees = async (filters: DateFilters = {}) => {
  const res = await api.get('/tasks/reports/planner/employees', { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/employees/{user_id}/items
export const getPlannerEmployeeItems = async (userId: string, filters: DateFilters & { status?: string } = {}) => {
  const res = await api.get(`/tasks/reports/planner/employees/${userId}/items`, { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/timeline
export const getPlannerTimeline = async (params: DateFilters & { group_by?: 'month' | 'week' } = {}) => {
  const res = await api.get('/tasks/reports/planner/timeline', { params });
  return res.data;
};

// GET /tasks/reports/planner/clients
export const getPlannerByClient = async (filters: DateFilters & { client_id?: string } = {}) => {
  const res = await api.get('/tasks/reports/planner/clients', { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/clients/{client_id}/items
export const getPlannerClientItems = async (clientId: string, filters: DateFilters & { status?: string } = {}) => {
  const res = await api.get(`/tasks/reports/planner/clients/${clientId}/items`, { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/vendors
export const getPlannerByVendor = async (filters: DateFilters & { vendor_id?: string } = {}) => {
  const res = await api.get('/tasks/reports/planner/vendors', { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/vendors/{vendor_id}/items
export const getPlannerVendorItems = async (vendorId: string, filters: DateFilters & { status?: string } = {}) => {
  const res = await api.get(`/tasks/reports/planner/vendors/${vendorId}/items`, { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/projects
export const getPlannerByProject = async (filters: DateFilters & { project_id?: string } = {}) => {
  const res = await api.get('/tasks/reports/planner/projects', { params: filters });
  return res.data;
};

// GET /tasks/reports/planner/projects/{project_id}/items
export const getPlannerProjectItems = async (projectId: string, filters: DateFilters & { status?: string } = {}) => {
  const res = await api.get(`/tasks/reports/planner/projects/${projectId}/items`, { params: filters });
  return res.data;
};
